import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import {Cell, Navbar, TabItem, TabContainer, TabContainerItem } from 'mint-ui'
import 'mint-ui/lib/style.css'

import Vant, {Lazyload} from 'vant';
import 'vant/lib/index.css';
import  '@/assets/font/iconfont.css';

import VueClipboard from 'vue-clipboard2'

//import SlideVerify from 'vue-monoplasty-slide-verify'

Vue.use(Vant);
Vue.use(Lazyload);
Vue.use(VueClipboard)
//Vue.use(SlideVerify)

const antdComponents = [
  Cell,
  TabItem,
  Navbar,
  TabContainer,
  TabContainerItem
];
antdComponents.forEach(module => {
  const component = module.default || module
  if (component.name) {
    Vue.component(component.name, component) //全局注册
  }
})

//Vue.use(MintUI)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
